const DEFAULT_CONTACT_API_URL = "http://localhost:2512/api/consultas";
export const CONTACT_API_ERROR_CODES = {
  PREVIOUS_INQUIRY_BLOCKED: "previous_inquiry_blocked",
};

function sanitizeUrl(value) {
  return String(value || "").trim();
}

function resolveUrlFromBase(baseUrl) {
  const normalizedBaseUrl = sanitizeUrl(baseUrl);

  if (!normalizedBaseUrl) {
    return "";
  }

  try {
    const baseWithTrailingSlash = normalizedBaseUrl.endsWith("/")
      ? normalizedBaseUrl
      : `${normalizedBaseUrl}/`;

    return new URL("/api/consultas", baseWithTrailingSlash).toString();
  } catch (_error) {
    return "";
  }
}

export function resolveContactApiUrl() {
  const explicitContactApiUrl = sanitizeUrl(process.env.REACT_APP_CONTACT_API_URL);

  if (explicitContactApiUrl) {
    return explicitContactApiUrl;
  }

  const urlFromBase = resolveUrlFromBase(process.env.REACT_APP_CONTACT_API_BASE_URL);

  return urlFromBase || DEFAULT_CONTACT_API_URL;
}

async function parseJsonSafely(response) {
  try {
    return await response.json();
  } catch (_error) {
    return null;
  }
}

export function isPreviousInquiryBlockedError(error) {
  return (
    error?.status === 429 || error?.code === CONTACT_API_ERROR_CODES.PREVIOUS_INQUIRY_BLOCKED
  );
}

export async function submitContactInquiry(contactApiUrl, payload) {
  const response = await fetch(contactApiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
  const data = await parseJsonSafely(response);

  if (!response.ok) {
    const error = new Error(
      data?.error || `No se pudo enviar la consulta (${response.status})`
    );
    error.status = response.status;
    error.code = data?.code || "";
    error.retryAt = data?.retryAt || "";
    throw error;
  }

  return data;
}
